export const parsePriceToNumber = (value: string | undefined | null): number =>
  Number(value ? value.replace(/\D/g, '') : 0);
